import React, { useState } from "react";

import { FiSearch, FiAlertTriangle, FiTool, FiCpu } from "react-icons/fi";

import axios from "axios";
import { API_BASE } from "../../apiConfig"; // ajusta la ruta según tu estructura


export default function IncidenciasCrear() {
  const [buscar, setBuscar] = useState("");
  const [equipoData, setEquipoData] = useState(null);
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    descripcion: "",
    estadoNuevo: "EN REPARACIÓN",
    refacciones: "",
    reemplazo: false,
    nivelRiesgo: "CRITICO",
    reportadoPor: "Administrador",
  });

  // ===============================
  // BUSCAR EQUIPO
  // ===============================
  const buscarEquipo = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_BASE}/inventario/buscar`, {
        params: { serie: buscar },
      });
      setEquipoData(res.data);
    } catch {
      alert("No se encontró ningún equipo con esa serie.");
    } finally {
      setLoading(false);
    }
  };

  // ===============================
  // ENVIAR INCIDENCIA
  // ===============================
  const enviar = async () => {
    try {
      await axios.post(`${API_BASE}/incidencias`, {
        idEquipo: equipoData.id,
        equipo: equipoData.equipo,
        serie: equipoData.serie,
        marca: equipoData.marca,
        municipio: equipoData.municipio,
        oficina: equipoData.oficina,
        modulo: equipoData.modulo,
        descripcion: form.descripcion,
        refacciones: form.refacciones.split(","),
        reemplazo: form.reemplazo,
        estadoNuevo: form.estadoNuevo,
        nivelRiesgo: form.nivelRiesgo,
        reportadoPor: form.reportadoPor,
        fechaReporte: new Date().toISOString(),
      });

      alert("Incidencia registrada correctamente.");
    } catch {
      alert("Error al guardar la incidencia.");
    }
  };

  return (
    <div className="p-8">

      {/* ============================================= */}
      {/* BUSCADOR DE EQUIPO */}
      {/* ============================================= */}
      <div className="bg-white border border-slate-200 rounded-xl shadow-sm p-6 mb-10">
        <label className="text-sm font-medium text-slate-700">
          Buscar equipo por número de serie
        </label>

        <div className="flex gap-3 mt-2">
          <input
            className="w-full bg-slate-50 border border-slate-300 rounded-xl px-4 py-3 focus:ring-2 focus:ring-indigo-400 focus:bg-white transition-all"
            placeholder="Ej. CNK2271RVS"
            value={buscar}
            onChange={(e) => setBuscar(e.target.value)}
          />

          <button
            onClick={buscarEquipo}
            className="bg-indigo-600 hover:bg-indigo-700 text-white px-6 rounded-xl flex items-center gap-2 shadow-sm transition-all"
          >
            <FiSearch size={16} />
            Buscar
          </button>
        </div>
      </div>

      {/* ============================================= */}
      {/* TARJETA — EQUIPO ENCONTRADO */}
      {/* ============================================= */}
      {equipoData && (
        <div className="bg-white border border-slate-200 rounded-xl shadow-sm p-8 mb-12">

          <div className="flex items-center gap-3 mb-6">
            <FiCpu size={26} className="text-blue-600" />
            <h2 className="text-2xl font-semibold text-slate-800 tracking-tight">
              Equipo Encontrado
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

            <SaasInfo label="Equipo" value={equipoData.equipo} />
            <SaasInfo label="Marca" value={equipoData.marca} />
            <SaasInfo label="Número de Serie" value={equipoData.serie} />

            <div>
              <p className="text-xs font-medium text-slate-500 uppercase tracking-wide mb-1">
                Estado Actual
              </p>
              <span
                className={`px-3 py-1 text-sm font-medium rounded-full 
                  ${equipoData.estadoEquipo === "BUENO" ? "bg-green-100 text-green-700" : ""}
                  ${equipoData.estadoEquipo === "EN REPARACIÓN" ? "bg-amber-100 text-amber-700" : ""}
                  ${equipoData.estadoEquipo === "NO OPERATIVO" ? "bg-red-100 text-red-700" : ""}
                `}
              >
                {equipoData.estadoEquipo}
              </span>
            </div>

          </div>
        </div>
      )}

      {/* ============================================= */}
      {/* FORMULARIO DE INCIDENCIA */}
      {/* ============================================= */}
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-8 mb-16">

        <div className="flex items-center gap-3 mb-8">
          <FiTool size={28} className="text-indigo-500" />
          <h2 className="text-2xl font-semibold text-slate-800 tracking-tight">
            Detalles de la Incidencia
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

          <div className="md:col-span-2">
            <label className="block text-sm font-medium text-slate-600 mb-1">
              Descripción del problema *
            </label>
            <textarea
              rows="4"
              placeholder="Describe detalladamente el problema presentado..."
              className="w-full bg-slate-50 border border-slate-300 rounded-xl px-4 py-3 
              focus:ring-2 focus:ring-indigo-400 focus:bg-white transition-all shadow-sm"
              onChange={(e) =>
                setForm({ ...form, descripcion: e.target.value })
              }
            ></textarea>
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-600 mb-1">
              Refacciones necesarias (coma)
            </label>
            <input
              placeholder="Ej. Rodillo, fuente de poder..."
              className="w-full bg-slate-50 border border-slate-300 rounded-xl px-4 py-3
              focus:ring-2 focus:ring-indigo-400 focus:bg-white transition-all shadow-sm"
              onChange={(e) =>
                setForm({ ...form, refacciones: e.target.value })
              }
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-600 mb-1">
              Estado del equipo
            </label>
            <select
              className="w-full bg-slate-50 border border-slate-300 rounded-xl px-4 py-3
              focus:ring-2 focus:ring-indigo-400 focus:bg-white transition-all shadow-sm"
              onChange={(e) =>
                setForm({ ...form, estadoNuevo: e.target.value })
              }
            >
              <option>EN REPARACIÓN</option>
              <option>NO OPERATIVO</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-600 mb-1">
              Nivel de Riesgo
            </label>
            <select
              className="w-full bg-slate-50 border border-slate-300 rounded-xl px-4 py-3
              focus:ring-2 focus:ring-indigo-400 focus:bg-white transition-all shadow-sm"
              onChange={(e) =>
                setForm({ ...form, nivelRiesgo: e.target.value })
              }
            >
              <option value="CRITICO">CRÍTICO</option>
              <option value="MEDIO">MEDIO</option>
              <option value="BAJO">BAJO</option>
            </select>
          </div>

          <div className="md:col-span-2 flex items-center gap-3 mt-2">
            <input
              type="checkbox"
              className="w-5 h-5 accent-indigo-600"
              onChange={(e) =>
                setForm({ ...form, reemplazo: e.target.checked })
              }
            />
            <span className="font-medium text-slate-700">
              ¿Requiere reemplazo?
            </span>
          </div>
        </div>

        <div className="mt-10">
          <button
            onClick={enviar}
            className="bg-indigo-600 hover:bg-indigo-700 text-white px-12 py-3 
            rounded-xl text-lg font-semibold shadow-md transition-all active:scale-95"
          >
            Registrar Incidencia
          </button>
        </div>
      </div>
    </div>
  );
}

/* ============================================= */
function SaasInfo({ label, value }) {
  return (
    <div>
      <p className="text-xs font-medium text-slate-500 uppercase tracking-wide mb-1">
        {label}
      </p>
      <p className="text-lg font-semibold text-slate-800">{value}</p>
    </div>
  );
}

function SaasBadge({ label, value, color }) {
  const colors = {
    blue: "bg-blue-100 text-blue-700",
    purple: "bg-purple-100 text-purple-700",
    cyan: "bg-cyan-100 text-cyan-700",
    orange: "bg-orange-100 text-orange-700",
  };

  return (
    <div>
      <p className="text-xs font-medium text-slate-500 uppercase tracking-wide mb-1">
        {label}
      </p>
      <span className={`px-3 py-1 rounded-full text-sm font-medium ${colors[color]}`}>
        {value}
      </span>
    </div>
  );
}
